import React from "react";

import { Card, CardContent, Stack, Typography } from "@mui/material";

import { SchedulesContext } from "./context";

export interface SchedulesCardProps extends React.PropsWithChildren {}

const SchedulesCard: React.FC<SchedulesCardProps> = ({ children }) => {
  return (
    <SchedulesContext.Provider value={{ isStandalone: true }}>
      <Card sx={{ borderRadius: 2 }} variant="outlined">
        <CardContent sx={{ p: 0, pb: "0 !important" }}>
          <Stack
            alignItems="center"
            borderBottom={1}
            borderColor="divider"
            direction="row"
            justifyContent="space-between"
            p={2}
          >
            <Stack alignItems="center" direction="row" spacing={2}>
              <Typography variant="body2">Utgivningsscheman</Typography>
            </Stack>
          </Stack>

          {children}
        </CardContent>
      </Card>
    </SchedulesContext.Provider>
  );
};

export default SchedulesCard;
